<script lang="ts">
	import type { ExpenseNote } from './expense-note-context';
	import { page } from '$app/stores';
	import Input from '$lib/components/atoms/input/Input.svelte';
	import Switch from '$lib/components/atoms/switch/Switch.svelte';
	import TextArea from '$lib/components/atoms/textarea/TextArea.svelte';
	import { track } from '$lib/services/tracking/googleAnalytics';
	import { getSearchParamsStore } from '$lib/services/urls/searchParams';
	import * as m from '$paraglide/messages';

	export let expenseNote: ExpenseNote;

	const searchParams = getSearchParamsStore();

	$: ({ itineraryResultsStore } = $page.data);

	$: route
		= $searchParams.selectedRoute !== undefined
			? $itineraryResultsStore?.routes[$searchParams.selectedRoute]
			: undefined;

	$: routeHasTolls = !!route?.costs?.tolls?.amount;
	$: routeHasVignettes = !!route?.costs?.vignette?.amount;

	function handleFuelChange(event: Event) {
		const eventTarget = event.target as HTMLInputElement;
		const parsedValue = Number.parseFloat(eventTarget.value.replace(',', '.'));
		expenseNote.energyCostPerUnit = Number.isNaN(parsedValue) ? '' : parsedValue.toFixed(3);
	}
</script>

<Input
	label={route?.isEv
		? m.route_details__expense_note_section__edit__electricity()
		: m.route_details__expense_note_section__edit__fuel()}
	id="fuel-price"
	ariaLabel={route?.isEv
		? m.route_details__expense_note_section__edit__electricity()
		: m.route_details__expense_note_section__edit__fuel()}
	bind:value={expenseNote.energyCostPerUnit}
	onchange={event => handleFuelChange(event)}
	onActivate={() =>
		track({
			action: 'itinerary_consumption_field',
			payload: {
				action: 'edit',
			},
		})}
/>
<div class="flex flex-col gap-1">
	<div class="text-sm">{m.route_details__expense_note_section__edit__include()}</div>
	<Switch
		id="energy"
		text={route?.isEv
			? m.route_details__expense_note_section__electricity()
			: m.route_details__expense_note_section__fuel()}
		bind:checked={expenseNote.includeEnergy}
	/>
	<Switch
		id="tolls"
		text={m.route_details__expense_note_section__tolls()}
		bind:checked={expenseNote.includeTolls}
		disabled={!routeHasTolls}
	/>
	<Switch
		id="vignettes"
		text={m.route_details__expense_note_section__vignette()}
		bind:checked={expenseNote.includeVignettes}
		disabled={!routeHasVignettes}
	/>
</div>
<div class="text-sm text-bold">{m.route_details__expense_note_section__edit__legal_info()}</div>
<Input
	label={m.route_details__expense_note_section__edit__identity()}
	id="identity"
	ariaLabel={m.route_details__expense_note_section__edit__identity()}
	bind:value={expenseNote.identity}
	placeholder={m.route_details__expense_note_section__edit__identity_placeholder()}
	onActivate={() =>
		track({
			action: 'itinerary_legal_info',
			payload: {
				action: 'edit',
			},
		})}
/>
<Input
	label={m.route_details__expense_note_section__edit__travel_date()}
	id="travel-date"
	ariaLabel={m.route_details__expense_note_section__edit__travel_date()}
	bind:value={expenseNote.date}
/>
<TextArea
	label={m.route_details__expense_note_section__edit__additional_data()}
	ariaLabel={m.route_details__expense_note_section__edit__additional_data()}
	id="additional-info"
	bind:value={expenseNote.additionalInfo}
	maxlength={200}
	placeholder={m.route_details__expense_note_section__edit__additional_data_placeholder()}
/>
